import { render, staticRenderFns } from "./PrestigeInventory.vue?vue&type=template&id=5705c7ba"
import script from "./PrestigeInventory.vue?vue&type=script&lang=js"
export * from "./PrestigeInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports